import { connect } from 'react-redux';

import StatementCreationPage from 'pages/statement-creation-page';
import { selectedProjectLoaded } from 'store/actions/selected-project-actions';
import { finishStatementCreation } from 'store/actions/statement-creation-actions';

const mapStateToProps = ({ data: { featureInfo, currentUser } }, ownProps) => ({
  featureInfo,
  currentUser,
  params: ownProps.params, // Pass through params from ProtectedRoute
});

const mapDispatchToProps = {
  finishStatementCreation,
  selectedProjectLoaded,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StatementCreationPage);
